export type ProductCategoryInput = {
  priCateName?: string | null;
  secCateName?: string | null;
  terCateName?: string | null;
};

export function printProductCategory(product: ProductCategoryInput | null | undefined): string {
  if (!product) return "";
  return [product.priCateName, product.secCateName, product.terCateName].filter((item) => item).join(" > ");
}
